import {useQueries} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import userService from "../../../services/user-service";
import modulesService from "../../../services/modules-service";

const UseFetchData = () => {

    const queries = useQueries({
        queries: [
            {
                queryFn: () => projectService.options().then(({data}) => data),
                queryKey: ['projects'],
                retry: 0
            },
            {
                queryFn: () => userService.getResponsibles().then(({data}) => data),
                queryKey: ['devs'],
                retry: 0
            },
            {
                queryFn: () => modulesService.modulesOptionsIdValue().then(({data}) => data),
                queryKey: ['groups'],
                retry: 0
            },
            {
                queryFn: () => userService.getResponsibles().then(({data}) => data),
                queryKey: ["responsibles"],
                retry: 0
            },
        ]
    });

    return {
        projects: queries[0].data,
        devs: queries[1].data,
        groups: queries[2].data,
        responsibles: queries[3].data,
    }
};

export default UseFetchData;